import { render, staticRenderFns } from "./html-custom-attributes.vue?vue&type=template&id=5c6e229c&scoped=true&"
import script from "./html-custom-attributes.vue?vue&type=script&lang=js&"
export * from "./html-custom-attributes.vue?vue&type=script&lang=js&"
import style0 from "./html-custom-attributes.vue?vue&type=style&index=0&id=5c6e229c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e229c",
  null
  
)

export default component.exports